// Author SWL
// Date 2025-04-08 12:59:10

class EmArchToolChangeRecord {
constructor({
        id = null,
        toolId = '',
        changeTypeId = '',
        quantity = '',
        initiator = '',
        initiatorNumber = '',
        initiatorLocation = '',
        uniqueCode = '',
        changeFlowId = '',
        inTime = '',
        attachments = '',
        remark = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.toolId = toolId;
    this.changeTypeId = changeTypeId;
    this.quantity = quantity;
    this.initiator = initiator;
    this.initiatorNumber = initiatorNumber;
    this.initiatorLocation = initiatorLocation;
    this.uniqueCode = uniqueCode;
    this.changeFlowId = changeFlowId;
    this.inTime = inTime;
    this.attachments = attachments;
    this.remark = remark;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new EmArchToolChangeRecord();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.archive.emArchToolChangeRecord.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'toolId',
        label: 'label.em.archive.emArchToolChangeRecord.grid.toolId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'changeTypeName',
        label: 'label.em.archive.emArchToolChangeRecord.grid.changeTypeName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'quantity',
        label: 'label.em.archive.emArchToolChangeRecord.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'initiator',
        label: 'label.em.archive.emArchToolChangeRecord.grid.initiator',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'initiatorNumber',
        label: 'label.em.archive.emArchToolChangeRecord.grid.initiatorNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'initiatorLocation',
        label: 'label.em.archive.emArchToolChangeRecord.grid.initiatorLocation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'uniqueCode',
        label: 'label.em.archive.emArchToolChangeRecord.grid.uniqueCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'changeFlowId',
        label: 'label.em.archive.emArchToolChangeRecord.grid.changeFlowId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inTime',
        label: 'label.em.archive.emArchToolChangeRecord.grid.inTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'toolType',
        label: 'label.em.archive.emArchToolChangeRecord.grid.toolType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'modelNumber',
        label: 'label.em.archive.emArchToolChangeRecord.grid.modelNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'identificationCode',
        label: 'label.em.archive.emArchToolChangeRecord.grid.identificationCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchToolChangeRecord.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'detailType',
        label: 'label.em.archive.emArchToolChangeRecord.grid.detailType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'department',
        label: 'label.em.archive.emArchToolChangeRecord.grid.department',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseKeeper',
        label: 'label.em.archive.emArchToolChangeRecord.grid.warehouseKeeper',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseNumber',
        label: 'label.em.archive.emArchToolChangeRecord.grid.warehouseNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'currentCode',
        label: 'label.em.archive.emArchToolChangeRecord.grid.currentCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'description',
        label: 'label.em.archive.emArchToolChangeRecord.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectNumber',
        label: 'label.em.archive.emArchToolChangeRecord.grid.projectNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.archive.emArchToolChangeRecord.grid.attachmentsList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeRecord.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    toolIdFilter : '',
    changeTypeIdFilter : '',
    quantityFilter : '',
    initiatorFilter : '',
    initiatorNumberFilter : '',
    initiatorLocationFilter : '',
    uniqueCodeFilter : '',
    changeFlowIdFilter : '',
    inTimeRteFilter : '',
    inTimeLteFilter : '',
    toolTypeFilter : '',
    modelNumberFilter : '',
    identificationCodeFilter : '',
    toolNameFilter : '',
    detailTypeFilter : '',
    currentCodeFilter : '',
    descriptionFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'toolIdFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.toolId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchTool'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'changeTypeIdFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.changeTypeId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChangeType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiatorFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.initiator',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiatorNumberFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.initiatorNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiatorLocationFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.initiatorLocation',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'uniqueCodeFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.uniqueCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'changeFlowIdFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.changeFlowId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChange'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inTimeRteFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.inTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inTimeLteFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.inTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'toolTypeFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.toolType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'modelNumberFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.modelNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'identificationCodeFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.identificationCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'toolNameFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.toolName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'detailTypeFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.detailType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'currentCodeFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.currentCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'descriptionFilter',
        label: 'label.em.archive.emArchToolChangeRecord.filter.description',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'toolId',
        label: 'label.em.archive.emArchToolChangeRecord.entity.toolId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchTool'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'changeTypeId',
        label: 'label.em.archive.emArchToolChangeRecord.entity.changeTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChangeType'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'quantity',
        label: 'label.em.archive.emArchToolChangeRecord.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiator',
        label: 'label.em.archive.emArchToolChangeRecord.entity.initiator',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiatorNumber',
        label: 'label.em.archive.emArchToolChangeRecord.entity.initiatorNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'initiatorLocation',
        label: 'label.em.archive.emArchToolChangeRecord.entity.initiatorLocation',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'uniqueCode',
        label: 'label.em.archive.emArchToolChangeRecord.entity.uniqueCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'changeFlowId',
        label: 'label.em.archive.emArchToolChangeRecord.entity.changeFlowId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchToolChange'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inTime',
        label: 'label.em.archive.emArchToolChangeRecord.entity.inTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolChangeRecord.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.archive.emArchToolChangeRecord.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachments'
                }
        }
]

export {EmArchToolChangeRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
